import { Link } from "react-router-dom";
import type { Article } from "@/types";

interface ArticleCardProps {
  article: Article;
  variant?: "row" | "feature";
}

export default function ArticleCard({ article, variant = "row" }: ArticleCardProps) {
  if (variant === "feature") {
    return (
      <Link
        to={`/articles/${article.id}`}
        className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      >
        <div className="aspect-[16/9] w-full overflow-hidden bg-background-100">
          <img
            src={article.cover}
            alt={article.title}
            width={1200}
            height={675}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <span className="w-fit rounded-full bg-accent-100 px-3 py-0.5 text-xs text-accent-900">
            {article.categoryName}
          </span>
          <h3 className="mt-3 font-heading text-lg font-600 leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {article.excerpt}
          </p>
          <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
            <span>{article.author}</span>
            <span className="text-foreground-300">|</span>
            <span>{article.date}</span>
            <span className="text-foreground-300">|</span>
            <span>{article.readMinutes} 分钟阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/articles/${article.id}`}
      className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-lg bg-background-100 sm:h-36 sm:w-56">
        <img
          src={article.cover}
          alt={article.title}
          width={1200}
          height={675}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col">
        <span className="w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-900">
          {article.categoryName}
        </span>
        <h3 className="mt-2 font-heading text-base font-600 leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-3 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" aria-hidden="true"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {article.readMinutes} 分钟
          </span>
        </div>
      </div>
    </Link>
  );
}